var React = require('react');

function BeepMobileInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"99","cy":"13","r":"91","stroke":"#0A9E50","strokeWidth":"16","key":0}),React.createElement("circle",{"cx":"103.5","cy":"9.5","r":"60.5","stroke":"#0A9E50","strokeWidth":"16","key":1}),React.createElement("ellipse",{"cx":"107.5","cy":"5","rx":"42.5","ry":"43","fill":"#0A9E50","key":2})]);
}

BeepMobileInline.defaultProps = {"width":"108","height":"112","viewBox":"0 0 108 112","fill":"none"};

module.exports = BeepMobileInline;

BeepMobileInline.default = BeepMobileInline;
